import type { SavingSettingsDetailsCountryConfig } from './SavingSettingsDetailsConfig';

export const settingsDetails: SavingSettingsDetailsCountryConfig = {
    displayDisposableBalance: true,
    averageSavings: {
        displayAccountOwner: true,
        displayPlainAccountNumber: true,
        displayBIC: true,
    },
    termDeposit: {
        displayAccountOwner: true,
        displayPlainAccountNumber: true,
        displayBIC: true,
    },
};
